import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, HeartPulse, Award, Microscope } from "lucide-react";
import { MEDIA } from "../data/brand";

const VALUES = [
  {
    icon: HeartPulse,
    title: "Trato cercano",
    desc: "Acompañamos a tu mascota y a ti en cada paso del tratamiento.",
  },
  {
    icon: Microscope,
    title: "Tecnología moderna",
    desc: "Equipos clínicos y de imagen para diagnósticos precisos.",
  },
  {
    icon: Award,
    title: "Equipo experto",
    desc: "Profesionales con experiencia en medicina y cirugía.",
  },
];

export default function About() {
  return (
    <section
      id="sobre-nosotros"
      data-testid="about-section"
      className="relative scroll-mt-24 bg-[#F8FAFC] py-20 md:py-28"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 lg:grid-cols-12 lg:px-12">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative lg:col-span-5"
        >
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-blue-900/10">
            <img
              src={MEDIA.about}
              alt="Interior moderno de la clínica veterinaria"
              className="aspect-[4/5] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 hidden w-56 rounded-2xl glass p-4 md:block">
            <div className="text-3xl font-display font-medium text-[#1E3A8A]">
              +10 años
            </div>
            <div className="mt-1 text-xs text-slate-600">
              cuidando mascotas en Copiapó
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#EA580C]">
            Sobre nosotros
          </span>
          <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Medicina veterinaria que combina ciencia, calidez y cercanía.
          </h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600">
            En CEQVet creemos que cada mascota merece la mejor atención. Por eso
            unimos la experiencia clínica de nuestro equipo con tecnología
            actual y un trato humano que tutores y pacientes valoran.
          </p>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {VALUES.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl border border-slate-200 bg-white p-5"
                data-testid={`about-value-${v.title.toLowerCase().replace(/\s/g, "-")}`}
              >
                <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#1E3A8A]/8 text-[#1E3A8A]">
                  <v.icon className="h-5 w-5" />
                </span>
                <div className="mt-3 font-display text-lg font-medium text-slate-900">
                  {v.title}
                </div>
                <p className="mt-1 text-sm text-slate-600">{v.desc}</p>
              </div>
            ))}
          </div>

          <ul className="mt-8 grid grid-cols-1 gap-2 sm:grid-cols-2">
            {[
              "Pabellón quirúrgico equipado",
              "Hospitalización supervisada",
              "Laboratorio clínico propio",
              "Protocolos clínicos actualizados",
            ].map((t) => (
              <li
                key={t}
                className="flex items-center gap-2 text-sm text-slate-700"
              >
                <CheckCircle2 className="h-4 w-4 text-emerald-600" />
                {t}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
